import React from "react";

const Header: React.FC = () => {
  return (
    <div className="header-section">
      <div className="header-content">
        {/* Left Column */}
        <div className="left-column">
          <h1 className="main-title">ept RADIO</h1>
          <p className="description">
            ept radio is a series of one-hour mixes curated by artists and creatives worldwide.
          </p>
          <p className="description description-2 suisse">
            each mix reflects the sounds that drive their imagination and movement, opening a window into the cultural rhythms shaping their work. shared across ept's digital platforms, the project builds a living sound archive, connecting communities through music, creativity, and movement.
          </p>
        </div>
        
        {/* Right Column */}
        {/* <div className="right-column">
          <p className="blue-text">
            "stonie blue for ept is a masterfully curated house mix designed to ignite movement and inspire action. showcasing a selection of uplifting tracks, stonie blue captures the raw energy of a nyc summer block party at its peak. more than a collection of songs, this mix is a demonstration of sonic intention, crafted to empower listeners to embrace their ideas and transform them into reality."
          </p>
          <p className="attribution suisse">anthony blue</p>
        </div> */}
      </div>
    </div>
  );
};

export default Header;
